import { Box, Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import getRequest from '../../../assets/helper/ApiHandler';

export default function Billing() {
    const toast = useRef(null);
    const [userData, setUserData] = useState([]);
    const [userDataDetails, setUserDataDetails] = useState([]);

    useEffect(() => {
        getUser();
        getUserDetails();
    }, []);

    const accountTypeName = (userData) => {
        const roles = userData.authorities || [];
        const roleName = roles.map(role => {
            const parts = role.split('_');
            if (parts.length > 2) {
                return parts.slice(1, -1).join('_');
            } else if (role.startsWith('ROLE_')) {
                return role.replace('ROLE_', '');
            }
            return role;
        }).join(', ');
        return roleName;
    };


    const getUser = async () => {
        try {
            const users = await getRequest(`/account`);
            setUserData(users);

        } catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error.message || error });
            }
        }
    }

    const getUserDetails = async () => {
        try {
            const users = await getRequest(`/admin/users`);
            setUserDataDetails(users);
        } catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error.message || error });
            }
        }
    }
    const getEmailsByRole = (userDataDetails) => {
        const adminEmail = ""; // Default admin email
        const adminUser = userDataDetails.find(user => user.authorities.includes("ROLE_ADMIN"));
        const adminUserEmail = adminUser ? adminUser.email : adminEmail;
        const intermediaryBillingUsers = userDataDetails.filter(user => user.authorities.includes("ROLE_INTERMEDIARY_BILLING"));
        const intermediaryBillingUserEmails = intermediaryBillingUsers.length > 0
            ? intermediaryBillingUsers.map(user => user.email)
            : [""];
        return { adminUserEmail, intermediaryBillingUserEmails };
    }

    const { adminUserEmail, intermediaryBillingUserEmails } = getEmailsByRole(userDataDetails);

    const formatEmails = (emails) => {
        if (emails.length === 0) return '';
        if (emails.length === 1) return emails[0];
        return emails.slice(0, -1).join(', ') + ' and ' + emails.slice(-1);
    }
    return (
        <div>
            <Toast ref={toast} position="bottom-right"></Toast>
            <Grid container spacing={2}>
                <Grid item xs={9} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} >
                    <Box className="card billing">
                    <Toast ref={toast} position="bottom-right"></Toast>
                        <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography variant="h6" noWrap component="div">
                                        <h2 className='fs-16-600'>Manage Billing</h2>
                                    </Typography>
                                    <p>Your account is on the <span className='brand-color'>INTERMEDIARY</span> plan. You will be invoiced <span className='brand-color'>MONTHLY</span> for using Omega.
                                        Your invoice for <span>May 1, 2024</span> for <span className='brand-color'>$34,000</span> is due latest by <span className='brand-color'>June 15, 2024</span>. You can view the
                                        billing history for your account <Link to='/settings/billing-history' className='billing-history-link'>here</Link>.</p>
                                    <Typography variant="h6" noWrap component="div">
                                        <h2 className='fs-12-600'>Billing Contacts</h2>
                                    </Typography>
                                    <p>
                                        Billing emails will be sent to <a href='#' className='brand-color'>{adminUserEmail}</a>
                                        {intermediaryBillingUserEmails.length > 0 && (
                                            <>
                                                {', '}
                                                {intermediaryBillingUserEmails.map((email, index) => (
                                                    <React.Fragment key={email}>
                                                        <a href='#' className='brand-color'>{email}</a>
                                                        {index === intermediaryBillingUserEmails.length - 2 ? ' and ' : (index < intermediaryBillingUserEmails.length - 2 ? ', ' : '')}
                                                    </React.Fragment>
                                                ))}
                                            </>
                                        )}
                                        . Only users with the role <span>“Admin”</span> and <span>“Billing”</span> shall receive the billing emails.
                                    </p>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </div>
    )
}
